import React, { useState } from 'react'
import Accordion from 'react-bootstrap/Accordion'
import Card from 'react-bootstrap/Card'
import PropTypes from 'prop-types'
import ReactMarkdown from 'react-markdown'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './fontAwesome'
import { useAccordionToggle } from 'react-bootstrap/AccordionToggle'



// VALIDACIONES DEL HEX Y LOGICA PARA COLOR DERIVADO
const HEX_COLOR_REGEX = /^#?([\da-f]{3}|[\da-f]{4}|[\da-f]{6}|[\da-f]{8})$/i

const normalizeHex = (value) => {
  if (typeof value !== 'string') return null
  const color = value.trim()
  if (!HEX_COLOR_REGEX.test(color)) return null

  const withHash = color.startsWith('#') ? color : `#${color}`
  if (withHash.length === 4) {
    return `#${withHash[1]}${withHash[1]}${withHash[2]}${withHash[2]}${withHash[3]}${withHash[3]}`
  }

  if (withHash.length === 5) {
    return `#${withHash[1]}${withHash[1]}${withHash[2]}${withHash[2]}${withHash[3]}${withHash[3]}${withHash[4]}${withHash[4]}`
  }

  return withHash.toLowerCase()
}

const hexToRgb = (hex) => ({
  r: parseInt(hex.slice(1, 3), 16),
  g: parseInt(hex.slice(3, 5), 16),
  b: parseInt(hex.slice(5, 7), 16)
})

const getAlpha = (hex) => (hex.length === 9 ? hex.slice(7, 9) : '')

const rgbToHex = ({ r, g, b }) =>
  `#${[r, g, b]
    .map((channel) => channel.toString(16).padStart(2, '0'))
    .join('')}`

const deriveActiveColor = (baseHex) => {
  const rgb = hexToRgb(baseHex)
  const derived = {
    r: Math.max(0, Math.round(rgb.r * 0.78)),
    g: Math.max(0, Math.round(rgb.g * 0.78)),
    b: Math.max(0, Math.round(rgb.b * 0.92))
  }

  return `${rgbToHex(derived)}${getAlpha(baseHex)}`
}

/// COMPONENTE
export const TabsContent = ({ data, title }) => {
  function CustomToggle({ children, eventKey, color }) {
    const [activeStates, setActiveState] = useState(false)
    const decoratedOnClick = useAccordionToggle(eventKey, () => {
      setActiveState(!activeStates)
    })
    let classActive = activeStates ? 'active' : ''
    const normalizedColor = normalizeHex(color)
    const customColorStyles = normalizedColor
      ? {
        '--tabs-inactive-local': normalizedColor,
        '--tabs-active-local': deriveActiveColor(normalizedColor)
      }
      : undefined

    return (
      <button
        type="button"
        className={`btn ${classActive}`}
        onClick={decoratedOnClick}
        style={customColorStyles}
      >
        {children}
        <FontAwesomeIcon icon={['fas', 'chevron-down']} size="sm" />
      </button>
    )
  }
  const tabs = data?.map((item) => (
      <Accordion defaultActiveKey="0" key={item.id}>
        {item?.itemsAccordion?.map((accordion) => (
          <Card key={accordion.id}>
            <Card.Header>
              <CustomToggle eventKey={accordion.id} color={accordion?.color}>
                <p className="mb-0 text-left" >
                  {accordion.title}
                </p>
              </CustomToggle>
            </Card.Header>
            <Accordion.Collapse eventKey={accordion.id}>
              <Card.Body>
                <ReactMarkdown
                  // eslint-disable-next-line react/no-children-prop
                  children={accordion.content}
                  className="publication-content-markdown"
                />
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        ))}
      </Accordion>
  ))
  return (
    <div className="tabs-component pb-5">
      <h2 className="text-uppercase font-weight-extra-bold ucc-text-blue">
        {title}
      </h2>
      <div className="py-4 tabs-text">
          {tabs}
      </div>
    </div>
  )
}

TabsContent.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.object.isRequired,
  eventKey: PropTypes.number.isRequired
}
